module.exports = __webpack_public_path__ + "img/documnet-icon.ea6a0a95.png";